import "./InstaImageGallery.css"
import React from "react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
// import 'swiper/css/navigation';

//  const testionialDataOld = [
//   {
//     imgSrc:"/images/creatives/testimonial-img-1.jpg",
//     imgText:true,
//     imgTitle:"Mr. John black",
//     imgContent:"Professional, courteous, and available staff for the healthcare needs of me and my family.",
//     imgPrice:"Crystallex Corp"
//   },
//   {
//     imgSrc:"/images/creatives/testimonial-img-2.jpg",
//     imgText:true,
//     imgTitle:"Mr. Jack Joe",
//     imgContent:"Professional, courteous, and available staff for the healthcare needs of me and my family.",
//     imgPrice:"Crystallex Corp"
//   },
//   {
//     imgSrc:"/images/creatives/testimonial-img-3.jpg",
//     imgText:true,
//     imgTitle:"Mr. Andy Mick",
//     imgContent:"Professional, courteous, and available staff for the healthcare needs of me and my family.",
//     imgPrice:"Crystallex Corp"
//   },
//   {
//     imgSrc:"/images/creatives/testimonial-img-1.jpg",
//     imgText:true,
//     imgTitle:"Mr. John black",
//     imgContent:"Professional, courteous, and available staff for the healthcare needs of me and my family.",
//     imgPrice:"Crystallex Corp"
//   },
//   {
//     imgSrc:"/images/creatives/testimonial-img-2.jpg",
//     imgText:true,
//     imgTitle:"Mr. Jack Joe",
//     imgContent:"Professional, courteous, and available staff for the healthcare needs of me and my family.",
//     imgPrice:"Crystallex Corp"
//   },
//   {
//     imgSrc:"/images/creatives/testimonial-img-3.jpg",
//     imgText:true,
//     imgTitle:"Mr. Andy Mick",
//     imgContent:"Professional, courteous, and available staff for the healthcare needs of me and my family.",
//     imgPrice:"Crystallex Corp"
//   },
  
  
// ]
 const testionialData = [
  {
    imgSrc:"/images/creatives/testimonial-img-1.webp",
    imgText:true,
    imgTitle:"Mr. Albert Gasparro",
    imgContent:"The best Healthcare solution for myself, my family and my executives.",
    imgPrice:"CEO, G GROUP DEVELOPMENT INC."
  },
  {
    imgSrc:"/images/creatives/testimonial-img-2.webp",
    imgText:true,
    imgTitle:"Mr. Marco Guglietti",
    imgContent:"Professional, courteous, and available staff for the healthcare needs of me and my family.",
    imgPrice:"PRESIDENT ROSEHEAVEN HOMES INC."
  },
  {
    imgSrc:"/images/creatives/testimonial-img-3.webp",
    imgText:true,
    imgTitle:"Mr. Robert A. Fung",
    imgContent:"The Toronto Clinic made it incredibly simple to take care of my health.",
    imgPrice:"CEO, CRYSTALLEX INTERNATIONAL CORP."
  },
  {
    imgSrc:"/images/creatives/testimonial-img-1.webp",
    imgText:true,
    imgTitle:"Mr. Albert Gasparro",
    imgContent:"The best Healthcare solution for myself, my family and my executives.",
    imgPrice:"CEO, G GROUP DEVELOPMENT INC."
  },
  {
    imgSrc:"/images/creatives/testimonial-img-2.webp",
    imgText:true,
    imgTitle:"Mr. Marco Guglietti",
    imgContent:"Professional, courteous, and available staff for the healthcare needs of me and my family.",
    imgPrice:"PRESIDENT ROSEHEAVEN HOMES INC."
  },
  {
    imgSrc:"/images/creatives/testimonial-img-3.webp",
    imgText:true,
    imgTitle:"Mr. Robert A. Fung",
    imgContent:"The Toronto Clinic made it incredibly simple to take care of my health.",
    imgPrice:"CEO, CRYSTALLEX INTERNATIONAL CORP."
  },
  
]

const pelvicMenData = [
     {imgTitle:"Ranold R.",imgText:true,imgSrc:"/images/icons/profile-icon-male.png",imgContent:"After struggling with urinary incontinence for years, I decided to try Venus Health. The Pelvic Chair treatment worked wonders for me! I regained control over my bladder, and the improvement in my confidence is beyond words."},
      
      {imgTitle:"Corry W. ",imgText:true,imgSrc:"/images/icons/profile-icon-male.png",imgContent:"The Venus Wave Therapy not only addressed my bladder leakage but also enhanced my sexual pleasure. It's an incredible feeling to regain control over my body. Thank you, Venus Health, for giving me the freedom I deserve!"},
      
      {imgTitle:"Ranold R.",imgText:true,imgSrc:"/images/icons/profile-icon-male.png",imgContent:"After struggling with urinary incontinence for years, I decided to try Venus Health. The Pelvic Chair treatment worked wonders for me! I regained control over my bladder, and the improvement in my confidence is beyond words."},
      
      {imgTitle:"Corry W.",imgText:true,imgSrc:"/images/icons/profile-icon-male.png",imgContent:"The Venus Wave Therapy not only addressed my bladder leakage but also enhanced my sexual pleasure. It's an incredible feeling to regain control over my body. Thank you, Venus Health, for giving me the freedom I deserve!"},
]

const pelvicWomenData = [
   {imgTitle:"Ranold R.",imgText:true,imgSrc:"/images/icons/profile-icon-male.png",imgContent:"After struggling with urinary incontinence for years, I decided to try Venus Health. The Pelvic Chair treatment worked wonders for me! I regained control over my bladder, and the improvement in my confidence is beyond words."},
    {imgTitle:"Amelia	E.",imgText:true,imgSrc:"/images/icons/profile-icon-female.png",imgContent:"The team at Venus Health made me feel comfortable and supported throughout my treatment. Their expertise and dedication to my well-being were evident at every step. I highly recommend Venus Health for anyone facing pelvic health challenges."},
    {imgTitle:"Corry W. ",imgText:true,imgSrc:"/images/icons/profile-icon-male.png",imgContent:"The Venus Wave Therapy not only addressed my bladder leakage but also enhanced my sexual pleasure. It's an incredible feeling to regain control over my body. Thank you, Venus Health, for giving me the freedom I deserve!"},
    
    {imgTitle:"Ranold R.",imgText:true,imgSrc:"/images/icons/profile-icon-male.png",imgContent:"After struggling with urinary incontinence for years, I decided to try Venus Health. The Pelvic Chair treatment worked wonders for me! I regained control over my bladder, and the improvement in my confidence is beyond words."},
    {imgTitle:"Amelia	E.",imgText:true,imgSrc:"/images/icons/profile-icon-female.png",imgContent:"The team at Venus Health made me feel comfortable and supported throughout my treatment. Their expertise and dedication to my well-being were evident at every step. I highly recommend Venus Health for anyone facing pelvic health challenges."},
    {imgTitle:"Corry W.",imgText:true,imgSrc:"/images/icons/profile-icon-male.png",imgContent:"The Venus Wave Therapy not only addressed my bladder leakage but also enhanced my sexual pleasure. It's an incredible feeling to regain control over my body. Thank you, Venus Health, for giving me the freedom I deserve!"},
]

function TestimonialsNew({
  subHeading = null,
  imgData=testionialData,
  heading = "",
  content="Discover why over 200 executives and their families trust The Toronto Clinic with their long-term health. Real stories. Proven outcomes. See the difference for yourself.",
  disableAutoplay = false,
  testimonialPelvicWomen=false,
  testimonialPelvicMen=false,
}) {

  // const handlePrevButtonClick = () => {
  //   const swiperInstance = document.querySelector('#testimonial-cards-slider').swiper;
  //   swiperInstance.slidePrev();
  // };
  
  // const handleNextButtonClick = () => {
  //   const swiperInstance = document.querySelector('#testimonial-cards-slider').swiper;
  //   swiperInstance.slideNext();
  // };

  if(testimonialPelvicMen)
  {
    imgData= pelvicMenData
  }
  if(testimonialPelvicWomen)
  {
    imgData= pelvicWomenData
  }

  return (
    <div className="InstaImageGallery-container standard-padding-space pb-0">
      <div className="w-100 container px-lg-3 px-auto my-3 mt-0 ">
        <div className="d-flex align-items-center w-100">
          <div className="col-12 text-center px-0">
            
          <div className="text-content mx-auto text-lg-center text-center">
            {
              heading ?
              <h3 className="mb-2 main-heading" >{heading}</h3>
              :
              <h3 className="mb-2 main-heading" >Trusted by Industry <span className="blue-txt">Leaders</span></h3>
            }
            {
              content &&
              <p className="body-paragraph color-dark mt-4 px-lg-5">{content}</p>
            }
          </div>
            <div className="container-fluid">
              <div className="row card-list" style={{ position: "relative" }}>
                <div className="col-12">
                  {/* {
                    disableAutoplay &&
                    <div className="swiper-button-prev swiper-button d-lg-block d-none" onClick={handlePrevButtonClick}></div>
                  } */}
                  <Swiper
                    spaceBetween={20}
                    pagination={true}
                    breakpoints={{
                      200: {
                        slidesPerView: 1,
                      },
                      1000: {
                        slidesPerView: 3,
                      },
                    }}
                    // navigation={disableAutoplay ? false : { 
                    //   nextEl: '.swiper-button-next',
                    //   prevEl: '.swiper-button-prev',
                    // }}
                    loop={true} 
                    autoplay={disableAutoplay ? false : { 
                      delay: 3500,
                      disableOnInteraction: false
                    }}
                    modules={[Autoplay]}
                    observer={true}
                    observeParents={true}
                    parallax={true}
                    className="testimonials-list pt-lg-5 pb-0 mt-lg-4"
                    id="testimonial-cards-slider"
                  >
                    
                    {
                      imgData.map((imgD, ind) => {
                        return (
                          <SwiperSlide key={ind}>
                            <div className="instaCardBox">
                              <img src={imgD.imgSrc} className="img-fluid" alt="slider images"/>
                              {imgD.imgText &&
                                <div className="content-box px-3 pb-3">
                                  <h4 className="title mt-lg-5 mt-3 pt-lg-3">{imgD.imgTitle}</h4>
                                  <p className="para body-paragraph ">{imgD.imgContent}</p>
                                  {imgD.imgPrice && imgD.imgPrice.split('\n').map((paragraph, index) => <p key={index} className='para body-paragraph my-2'>{paragraph}</p>)}
                                </div>
                              }
                            </div>
                          </SwiperSlide>
                        )
                      })
                    }
                  </Swiper>
                  {/* {
                    disableAutoplay &&
                    <div className="swiper-button-next swiper-button d-lg-block d-none" onClick={handleNextButtonClick}></div>
                  } */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TestimonialsNew;
